export default __webpack_public_path__ + "static/media/2017-hercules.c7a7fcf3.png";